import pepephoneParticular1 from './pepephoneParticular1';
import pepephoneParticular2 from './pepephoneParticular2';

export default {
    pepephoneParticular1,
    pepephoneParticular2,
};